import axios from 'axios';
import { Toast } from 'mint-ui';
import router from '../router/index';

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  // baseURL: "http://192.168.10.104:8080", // api 的 base_url
  timeout: 30000// request timeout
})
// console.log(process.env.BASE_API)
// response interceptor
service.interceptors.response.use(
  response => response,
  error => {
    Toast({
      message: '加载失败',
      position: 'bottom',
      duration: 2000
    })
    return Promise.reject(error)
  }
)

// http request 拦截器

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js